class BlogArticleSlider extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      if (typeof Swiper === 'undefined') return;
  
      const sliderEl = this.querySelector('[data-blog-slider]');
      if (!sliderEl) return;
  
      const nextEl = this.querySelector('.hero__button-next');
      const prevEl = this.querySelector('.hero__button-prev');
      const paginationEl = this.querySelector('.swiper-pagination');
  
      const slidesCount = sliderEl.querySelectorAll('.swiper-slide').length;
      if (slidesCount < 2) return;
  
      // eslint-disable-next-line no-new
      new Swiper(sliderEl, {
        slidesPerView: 2,
        spaceBetween: 18,
        loop: false,
        effect: 'slide',
        speed: 600,
        navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
        pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
      });
    }
  }
  
  customElements.define('blog-article-slider', BlogArticleSlider);